export default __webpack_public_path__ + "static/media/P800MANB1.ac43345f.pdf";